import {setPersistedAtValue} from '../../../actions/easiplusFuneralPlan/persistedAt'

export const easiplusFuneralPlanPersistedAt = (store, next, action) => {
    const result = next(action);
    store.dispatch(setPersistedAtValue());
    return result;
}